import React, { useEffect, useState } from 'react';
import NotificationHandler from './NotificationHandler';
import { enumUtil } from './Enum';
import { ServerRequestProtected } from './ServerDataRequest';
import Modal from 'react-bootstrap/Modal';
import Loader from '../Components/shared/Loader/Loader';
import ViewFileFormattedText from './ViewFileFormattedText';

const ViewTextFile = (props) => {
    const { isOpen, Data, Close, TableName, Name, Controller, Link, Method } = props;
    const API_URL_EDI = enumUtil.controller.EDI;




    const [isLoading, setIsLoading] = useState(false);
    const [viewFileData, setViewFileData] = useState([]);
    console.log(Data, 'DataFormVIewFile ');

    const handleViewFile = (Data) => {

        if (Data?.FileType === "HR") {
            NotificationHandler("Please Select Correct File", enumUtil.enumtoaster.error);
        } else {
            setViewFileData([]);
            setIsLoading(true);
            let requestPayload = {
                "ID": "",
                "TableName": TableName
            };
            if (Name === 'EDIReport') {
                requestPayload.ID = Data.DownloadFileID;
            } else if (Name === 'Activity') {
                requestPayload.ID = Data;
            } else if (Name === 'SubmissionHistory') {
                requestPayload.ID = Data.EDIClaimBatchID;
            }
            else if (Name === 'Payment') {
                requestPayload.ID = Data.FileID;
            }
            else if (Name === 'TransactionInformation') {
                requestPayload.ID = Data.DownloadFileID + "";
            }
            else if (Name === 'ClaimAccountSummary') {
                requestPayload.ID = Data.EDIClaimBatchID + "";
            }
            else if (Name === 'ElectronicSubmission') {
                requestPayload.ID = Data + "";
            }
            else if (Name === 'Eligibity') {
                requestPayload.ID = Data?.EligibilityLogID + "";
                requestPayload.Value = "271";

            }
            else if (Name === 'Response') {
                requestPayload.ID =  Data?.DownloadFileID + "";
            }
            else if (Name === 'ActivityGrid') {
                requestPayload.ID = Data + "";
            }
            ServerRequestProtected(Controller + Link, 'post', requestPayload)
                .then((response) => {
                    setIsLoading(false);
                    setViewFileData(response);
                })
                .catch((error) => {
                    setIsLoading(false);
                    // close()
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                });
        }
    };

    useEffect(() => {
        if (isOpen) {
            handleViewFile(Data);
        }
    }, [isOpen]);

    return (
        <>
            {isLoading ? <Loader /> : null}
            <Modal
                show={isOpen}
                onHide={Close}
                backdrop="static"
                keyboard={false}
                centered
                dialogClassName="app-modal modal-c-lg hk-resultCode-modal hk-modal-v1"
            >
                <Modal.Body>
                    <div className='d-flex justify-content-between align-items-center mb-3 px-10'>
                        <p className='heading fs-14 dark-clr'>Results</p>
                        <button className='btn-icon-transparent' onClick={Close}>
                            <i className="icon-x-cros fs-20 dark-clr cursor-pointer"></i>
                        </button>
                    </div>
                    <ol className='px-10'>
                        {viewFileData?.map((item, index) => (
                            <li className="list-AdvInfo" key={index}>
                                <ViewFileFormattedText originalText={item} />
                                {/* <div className='message_box'>
                                    <div className='content'>
                                        <p className='text'><span className='dot'></span> Message Header </p>
                                        <span className='text ms-1'> UNH</span>
                                    </div>
                                    <div className='content'>
                                        <p className='text'><span className='dot'></span> Message Identifier </p>
                                        <span className='text ms-1'> S009</span>
                                    </div>
                                    <div className='content'>
                                        <p className='text'><span className='dot'></span> Message Identifier </p>
                                    </div>
                                    <div className='content'>
                                        <p className='text'><span className='dot'></span> Message Identifier </p>
                                        <p className='text ms-1 text_color'>DESADV Despatch advice message</p>
                                    </div>
                                </div> */}
                            </li>
                        ))}
                    </ol>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ViewTextFile;
